import PerfectScrollbar from 'perfect-scrollbar';

const popupTemplate = require('./filter-popup.pug');
require('../../../assets/svg/close.svg');

export default {
  template: popupTemplate(),
  delimiters: ['${', '}}'],
  props: ['info'],
  data() {
    return {
      search: '',
    };
  },
  computed: {
    tabLength() {
      return 100 / this.info.tabs.length;
    },
    activeTab() {
      return this.info.tabs.find(el => el.active).name;
    },
    activeContent() {
      return this.info.content.find(el => el.name === this.activeTab);
    },
    searchPlaceholder() {
      return this.activeContent.search;
    },
    visibleCheckboxes() {
      if (this.activeContent) {
        if (this.search.length > 0) {
          const matched = this.activeContent.list.filter(el => el.text.match(new RegExp(this.search, 'ig')));
          return matched.length !== 0 ? matched : [];
        }
        return this.activeContent.list;
      }
      return [];
    },
  },
  methods: {
    closePopup() {
      this.$emit('closepopup');
      window.bodyLock.clearAllBodyScrollLocks();
      this.save();
    },
    switchTab(tab) {
      if (this.activeTab !== tab.name) {
        this.save(false);
        this.info.tabs.forEach((el) => {
          el.active = el.name === tab.name;
        });
        this.search = '';

        this.$nextTick(() => {
          if (this.scrollbar) this.scrollbar.update();
        });
      }
    },
    save(isSave = true, close = false) {
      const data = {};
      if (isSave) {
        const checked = this.visibleCheckboxes.filter(el => el.checked);
        if (checked.length !== 0) {
          data[`${this.activeContent.name}`] = checked.map(el => el.value);
        } else {
          data[`${this.activeContent.name}`] = [];
        }
        if (close) this.closePopup();
      } else {
        this.search = '';
        this.visibleCheckboxes.forEach((el) => {
          el.checked = false;
        });
        data[`${this.activeContent.name}`] = [];
      }
      this.$emit('savedata', data);
    },
  },
  mounted() {
    this.$nextTick(() => {
      window.bodyLock.disableBodyScroll(this.$refs.main);
      if (window.innerWidth >= 768) {
        this.scrollbar = new PerfectScrollbar(this.$refs.checkboxes, {
          wheelPropagation: false,
          suppressScrollX: true,
          wheelSpeed: 0.5,
        });
      }
    });
  },
};



// WEBPACK FOOTER //
// ./bali-blocks/filter/popup/filter-popup.js